// extracted by mini-css-extract-plugin
module.exports = {"root":"SubCategoryTemplate_root__WflGx","useFade-fadeIn":"SubCategoryTemplate_useFade-fadeIn__5wHab","useFade-fadeOut":"SubCategoryTemplate_useFade-fadeOut__dklFS"};